import React from 'react';
import { Alert, Collapse, Space, Tag, Typography } from 'antd';

const { Text } = Typography;

export default function CoveredProductsList({ products = [] }) {
  if (!products.length) return null;

  return (
    <div className="glp1-section-block">
      <Text className="glp1-section-title">Bridge-covered products to verify</Text>
      <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Confirm the prescribed drug/formulation and current CMS NDC list before routing.
      </Text>
      <Collapse
        size="small"
        items={products.map((product) => ({
          key: product.name,
          label: `${product.name} (${product.formulations})`,
          children: (
            <div>
              {product.note ? (
                <Alert type="warning" showIcon style={{ marginBottom: 8 }} message={product.note} />
              ) : null}
              <Space size={[6, 6]} wrap>
                {(product.ndcs || []).map((ndc) => (
                  <Tag key={ndc} style={{ marginInlineEnd: 0 }}>
                    {ndc}
                  </Tag>
                ))}
              </Space>
            </div>
          ),
        }))}
      />
    </div>
  );
}
